module.exports = __webpack_public_path__ + "img/info.182d950e.svg";